// extracted by mini-css-extract-plugin
module.exports = {"root":"Followers_root__2S1Q4","audience":"Followers_audience__FDrd3","count":"Followers_count__3Dsuf","platform":"Followers_platform__OLcBK","link":"Followers_link__3JuES"};